var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
import { XbpmContext } from '@unitarius/xbpm-runtime';
var IFrameControl = /** @class */ (function (_super) {
    __extends(IFrameControl, _super);
    function IFrameControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IFrameControl.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var _a = this.state.def, code = _a.code, value = _a.value;
        var initialValue = typeof value === 'string' ? JSON.parse(value) : value;
        this.bridgeHostService = XbpmContext.getContext().getProvider('bridgeHostService');
        this.bridgeClientService = XbpmContext.getContext().getProvider('bridgeService');
        this.bridgeHostService.createIframe(code, this.iframeRef, initialValue);
    };
    IFrameControl.prototype.componentDidUpdate = function (_, prevState) {
        var _a = this.state.def, value = _a.value, code = _a.code;
        var prevValue = prevState.def.value;
        if (JSON.stringify(value) !== JSON.stringify(prevValue)) {
            if (prevValue && value) {
                this.bridgeClientService.navigate(__assign({ targetId: code }, value));
            }
        }
    };
    IFrameControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, code = def.code;
        return (React.createElement("div", { ref: function (ref) { return (_this.iframeRef = ref); }, id: code + '-iframeContainer', className: mapElementClass(frontOptions) }));
    };
    return IFrameControl;
}(FormBaseElement));
export { IFrameControl };
//# sourceMappingURL=IFrame.js.map